import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants/constants';
import { ILocationGroup } from 'src/interfaces/LocationGroup';
import { queryKeys } from 'src/utils';
import { lang } from 'src/utils';
import { improvedFailedToError } from 'src/utils/improvedFailedToError';

import { requestCCApi } from '../../../utils/axios-utils';
import { narrativeGenerators } from '../userActions/helper';

export const useCreateLocationGroup = () => {
  return useMutation({
    mutationFn: createLocationGroup,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.locationGroups.invalidateAll());
      queryClient.invalidateQueries(queryKeys.viewLocations.all('all'));
      queryClient.invalidateQueries(queryKeys.scheduleDayparts.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.scheduleDaypartOverrides.invalidateAll(),
      );
    },
  });
};

const createLocationGroup = async (
  payload: Omit<ILocationGroup, 'id' | 'created_at' | 'modified_at'>,
) => {
  const request = {
    name: payload.name,
    channel_name: payload.channel_name,
    layout_type_id: payload.layout_type_id,
    is_default: false,
    narrative: narrativeGenerators[COLLECTIONS.LOCATION_GROUPS][
      USER_ACTIONS.CREATE
    ](payload.name),
  };

  const response = await requestCCApi(
    {
      url: `/locationGroups`,
      method: 'POST',
      data: { data: request },
    },
    true,
    improvedFailedToError(lang.create, lang.locationGroup),
  );

  return response;
};
